import log from "loglevel";
import React, { useEffect, useRef, useState } from "react";
import "react-markdown-editor-lite/lib/index.css";
import { Col, Nav, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
// import { useWindowSize } from "hooks/useScreenSize";

export const PageInfoStudent = ({ pages }) => {
  const { pageid, courseId } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(null);
  const [key, setKey] = useState(pageid);

  const [allPages, setAllPages] = useState([]);
  const contentRef = useRef(null);
  const activeNavItemRef = useRef(null);
  const scrollContainerRef = useRef(null);

  log.log({ pages });

  useEffect(() => {
    setAllPages(pages);
  }, [pages]);

  useEffect(() => {
    log.log({ allPages, pageid });
    if (pageid != null) {
      if (pageid.toLowerCase() === "addpage") {
        if (allPages.length > 0) {
          let firstPageId = allPages[0].id;
          navigate(`/courseware/course/${courseId}/pages/${firstPageId}`);
        }
      } else {
        setPage(allPages.find((item) => `${item.id}` === pageid));
        setKey(pageid);
      }
    } else if (allPages.length > 0) {
      setPage(allPages[0]);
      setKey(allPages[0]?.id);
    }
  }, [allPages, courseId, navigate, pageid]);

  // Process images after content is rendered
  // useEffect(() => {
  //   if (contentRef.current) {
  //     const images = contentRef.current.querySelectorAll('img');
  //     images.forEach(img => {
  //       img.style.maxWidth = '100%';
  //       img.style.height = 'auto';
  //       img.style.objectFit = 'contain';
  //       img.style.display = 'block';
  //       // Optional: center images
  //       // img.style.margin = '0 auto';
  //     });
  //   }

  //   if (contentRef.current) {
  //     const tables = contentRef.current.querySelectorAll('table');
  //     const isMobile = width < 768;
  //     tables.forEach(table => {
  //       // Base styles for all tables
  //       table.style.borderCollapse = 'collapse';

  //       // Only apply these styles on mobile devices
  //       if (isMobile) {
  //         // Make the table responsive on mobile
  //         table.style.width = '100%';
  //         table.style.display = 'block';
  //         table.style.overflowX = 'auto';

  //         // Ensure the parent container doesn't overflow
  //         const parentDiv = table.parentElement;
  //         if (parentDiv) {
  //           parentDiv.style.maxWidth = '100%';
  //           parentDiv.style.overflowX = 'hidden';
  //         }
  //       }

  //       // Style table cells consistently
  //       const cells = table.querySelectorAll('td, th');
  //       cells.forEach(cell => {
  //         cell.style.padding = '8px';
  //         cell.style.border = '1px solid #ddd';
  //       });
  //     });
  //   }
  // }, [page, width]);

  useEffect(() => {
    if (contentRef.current) {
      // Image processing - keep as is
      const images = contentRef.current.querySelectorAll('img');
      images.forEach(img => {
        img.style.maxWidth = '100%';
        img.style.height = 'auto';
        img.style.objectFit = 'contain';
        img.style.display = 'block';
      });

      const tables = contentRef.current.querySelectorAll('table');

      tables.forEach(table => {
        // First, get any existing table wrapper
        let wrapper = table.closest('.table-responsive');

        // If no wrapper exists, create one
        if (!wrapper) {
          // Create a bootstrap responsive table wrapper
          wrapper = document.createElement('div');
          wrapper.className = 'table-responsive';

          // Ensure wrapper has proper Bootstrap styling plus important overrides
          wrapper.style.cssText = 'display: block !important; width: 100% !important; overflow-x: auto !important;';

          // Place the table inside the wrapper
          table.parentNode.insertBefore(wrapper, table);
          wrapper.appendChild(table);
        }

        // Make sure the table is wide enough to trigger scrolling on mobile
        table.classList.add('table');  // Add Bootstrap table class
        table.style.minWidth = '500px'; // Ensure table is wide enough to scroll

        // Style table cells consistently
        const cells = table.querySelectorAll('td, th');
        cells.forEach(cell => {
          cell.style.padding = '8px';
          cell.style.border = '1px solid #ddd';
        });
      });
    }
  }, [page]);

  // Scroll active nav item into view when it changes
  useEffect(() => {
    if (activeNavItemRef.current && scrollContainerRef.current) {
      // Get the active nav item and container
      const activeItem = activeNavItemRef.current;
      const container = scrollContainerRef.current;

      // Calculate positions
      const itemLeft = activeItem.offsetLeft;
      const itemWidth = activeItem.offsetWidth;
      const containerWidth = container.offsetWidth;
      const scrollLeft = container.scrollLeft;

      // Check if active item is not fully visible
      if (itemLeft < scrollLeft || itemLeft + itemWidth > scrollLeft + containerWidth) {
        // Calculate the position to center the item in the container
        const centerPosition = itemLeft - (containerWidth / 2) + (itemWidth / 2);
        // Scroll to that position smoothly
        container.scrollTo({
          left: centerPosition,
          behavior: 'smooth'
        });
      }
    }
  }, [key, page, allPages]);

  if (page == null) {
    // return <Spinner />;
    return <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "30vh", minHeight: "30svh" }}>
      <h5 className="text-muted">No Pages to Show</h5>
    </div>;
  }

  // const md = new MarkdownIt({ underline: true });

  return (
    <div className="bg-white">
      {
        Array.isArray(pages) && pages.length > 0 ? <>
          {/* Horizontally scrollable navigation on mobile */}
          <div ref={scrollContainerRef} className="px-3 py-3 overflow-auto hide-scrollbar">
            <Nav
              onSelect={(k) => setKey(k)}
              variant="pills"
              activeKey={key}
              // className="px-3 pb-3 pt-3 g-10"
              className="d-flex flex-nowrap"
            // id="isn-pills"
            >
              {pages.map((item, index) => {
                const isActive = `${item.id}` === key;
                return (
                  <Nav.Item key={item.id} ref={isActive ? activeNavItemRef : null} className="flex-shrink-0">
                    <Nav.Link as={Link} to={`/courseware/course/${courseId}/pages/${item.id}`} eventKey={item.id}>
                      {item.title}
                    </Nav.Link>
                  </Nav.Item>
                );
              })}
            </Nav>
          </div>
          {
            !page && <div className="my-4">
              <h5 className="text-center text-muted">No Page Selected</h5>
            </div>
          }
          <Row style={styles.outerbox}>
            <Col xs={12} className="px-0">
              <h4 style={styles.headerStyle}>{page?.title}</h4>
            </Col>
            <Col xs={12} className="px-0">
              {/* <hr
                style={{
                  marginLeft: 5,
                  marginRight: 5,
                  height: "2px",
                  border: "none",
                  backgroundColor: "grey",
                }}
              /> */}
              <hr className="mx-0 border-1 border-secondary opacity-75" />

            </Col>
            <Col xs={12} style={styles.contentWrapper}>
              <div
                ref={contentRef}
                style={styles.responsiveContent}
                dangerouslySetInnerHTML={{
                  __html: page?.description,
                }}
              />
            </Col>
          </Row>
        </> : <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "30vh", minHeight: "30svh" }}>
          <h5 className="text-muted">No Pages to Show</h5>
        </div>
      }

    </div>
  );
};

const styles = {
  outerbox: {
    border: "1px solid #ccc",
    marginLeft: 15,
    marginRight: 15,
    padding: 20,
    width: 'calc(100% - 30px)',
    maxWidth: '100%',
  },
  headerStyle: {
    color: "grey",
    display: "inline",
  },
  contentWrapper: {
    padding: 0,
    width: '100%',
    boxSizing: 'border-box',
  },
  responsiveContent: {
    width: '100%',
    maxWidth: '100%',
    overflowX: 'hidden',
    boxSizing: 'border-box',
  }
};

export default PageInfoStudent;
